import Swal from "sweetalert2";

export const swalAlertSuccess = (title, text, onConfirm) => {
  Swal.fire({
    title: title,
    text: text,
    icon: "success",
    confirmButtonText: "Aceptar",
  }).then(() => {
    onConfirm();
  });
};

export const swalAlertDanger = (title, text, onConfirm) => {
  Swal.fire({
    title: title,
    text: text,
    icon: "error",
    confirmButtonText: "Aceptar",
  }).then(() => {
    onConfirm();
  });
};

export const swalAlertErrorFetch = (onConfirm) => {
  Swal.fire({
    title: "Error al obtener los datos",
    icon: "error",
    confirmButtonText: "Aceptar",
  }).then(() => {});
};

export const swalAlertInfo = (title, text, onConfirm) => {
  Swal.fire({
    title: title,
    text: text,
    icon: "info",
    confirmButtonText: "Aceptar",
  }).then(() => {
    onConfirm();
  });
};

export const swalAlertInfoOrange = (title, message, onConfirm) => {
  Swal.fire({
    title: title,
    message: message,
    icon: "info",
    iconColor: "orange",
    confirmButtonText: "Aceptar",
  }).then(() => {
    onConfirm();
  });
};

export function swalConfirmationAlert(title, message, onConfirm) {
  Swal.fire({
    title: title,
    text: message,
    icon: "question",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Confirmar",
    cancelButtonText: "Cancelar",
  }).then((result) => {
    if (result.isConfirmed) {
      onConfirm();
    }
  });
}

export const swalAlertTimer = (title, timerDuration) => {
  return new Promise((resolve) => {
    let timerInterval;
    Swal.fire({
      title: title,
      timer: timerDuration,
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading();
      },
      willClose: () => {
        clearInterval(timerInterval);
        resolve(); // Resuelve la promesa cuando el temporizador termina
      },
    }).then((result) => {
      if (result.dismiss === Swal.DismissReason.timer) {
      }
    });
  });
};

export const swalAlertTextarea = (title, onConfirm) => {
  Swal.fire({
    title: title,
    input: "textarea",
    inputAutoFocus: true,
    showCancelButton: true,
    cancelButtonText: "CANCELAR",
    cancelButtonColor: "#d33",
    showLoaderOnConfirm: true,
    confirmButtonText: "CONFIRMAR",
    confirmButtonColor: "#3085d6",
    preConfirm: (inputValue) => {
      if (!inputValue.trim()) {
        Swal.showValidationMessage("El campo no puede estar vacío");
      }
      return inputValue;
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const inputValue = result.value;
      onConfirm(inputValue);
    }
  });
};

export const swalInputAlert = async (title, onConfirm) => {
  Swal.fire({
    title: title,
    input: "text",
    inputAttributes: {
      autocapitalize: "off",
    },
    showCancelButton: true,
    cancelButtonText: "CANCELAR",
    cancelButtonColor: "#d33",
    showLoaderOnConfirm: true,
    confirmButtonText: "CONFIRMAR",
    confirmButtonColor: "#3085d6",
    preConfirm: (inputValue) => {
      if (!inputValue.trim()) {
        Swal.showValidationMessage("El campo no puede estar vacío");
      }
      return inputValue;
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const inputValue = result.value;
      onConfirm(inputValue);
    }
  });
};

export const swalSelectAlert = async (title, options, onConfirm) => {
  Swal.fire({
    title: title,
    input: "select",
    inputOptions: options.map((expense) => expense.description_expense),
    showCancelButton: true,
    cancelButtonText: "CANCELAR",
    cancelButtonColor: "#d33",
    showLoaderOnConfirm: true,
    confirmButtonText: "CONFIRMAR",
    confirmButtonColor: "#3085d6",
    preConfirm: (selectedDescription) => {
      const selectedOption = options.find(
        (expense) => expense.description_expense === selectedDescription
      );
      if (selectedOption) {
        Swal.showValidationMessage("Debes seleccionar una opción");
      }
      return selectedOption;
    },
  }).then((result) => {
    if (result.isConfirmed) {
      const selectedOption = result.value;
      onConfirm(selectedOption);
    }
  });
};

export const showLoadingSpinner = async () => {
  Swal.fire({
    title: "CARGANDO SOLICITUD...",
    allowOutsideClick: false,
    showConfirmButton: false,
    willOpen: () => {
      Swal.showLoading();
    },
  });
};

export function hideLoadingSpinner() {
  Swal.close();
}